import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { MatNotificationService } from './mat-notifications.service';

@Component({
	selector: 'mat-notifications',
	templateUrl: './mat-notifications.component.html',
	styleUrls: ['./mat-notifications.component.scss'],
	animations: [
		trigger('animatedNotificationCard', [
			transition(':enter', [
				style({ transform: 'scale(.8)', opacity: 0, height: 0, 'padding-top': 0, 'padding-bottom': 0, 'margin-bottom': 0 }),
				animate('250ms cubic-bezier(0, 0, .2, 1)', 
					style({ transform: 'scale(1)', opacity: 1,  height: '*', 'padding-top': '*', 'padding-bottom': '*', 'margin-bottom': '*' })
				)
			]),
			transition(':leave', [
				style({ transform: 'scale(1)', opacity: 1, height: '*' }),
				animate('150ms cubic-bezier(.4, 0, 1, 1)', 
					style({ transform: 'scale(.5)', opacity: 0, height: 0, 'padding-top': 0, 'padding-bottom': 0, 'margin-bottom': 0 })
				) 
			])
		])
	]
})
export class MatNotificationsComponent {

	constructor(public notificationService: MatNotificationService) {}
}
